import { connect } from 'react-redux';
import { showSuggestReportModal } from 'actions/modalActions';
import { sendSuggestReportRequest } from 'actions/reportActions';
import SuggestReportItem from 'modules/report/components/menu/suggestReportItem';

export default connect(null, dispatch => ({
    showSuggestReportModal: () =>
        dispatch(showSuggestReportModal(data => dispatch(sendSuggestReportRequest.request(data)))),
}))(SuggestReportItem);
